import styled from 'styled-components';
import { rgba } from 'polished';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

// CONSTANTS
import { WHITE } from '@/constants/colors';

export const CloseIcon = styled(IconButton)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 1.5rem;
`;

export const DialogStyled = styled(Dialog)`
  .MuiDialog-paper {
    overflow-y: visible;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    width: calc(100% - 3rem);
  }

  .MuiDialogContent-root {
    padding-bottom: 2.4rem;

    display: flex;
    flex-direction: column;

    &:first-child {
      padding-top: 6rem;
    }
  }

  .fmb-logo {
    position: relative;
    overflow: hidden;
    cursor: pointer;

    svg {
      width: 100%;
      height: auto;
    }

    &::before,
    &::after {
      position: absolute;
      display: block;
      content: '';
      left: 0;
      top: 0;
      bottom: 0;
      width: 12rem;
      background: linear-gradient(
        90deg,
        ${rgba(WHITE, 1)} 0%,
        ${rgba(WHITE, 1)} 30%,
        ${rgba(WHITE, 0)} 100%
      );
    }

    &::after {
      left: auto;
      right: 0;
      background: linear-gradient(
        270deg,
        ${rgba(WHITE, 1)} 0%,
        ${rgba(WHITE, 1)} 30%,
        ${rgba(WHITE, 0)} 100%
      );
    }
  }
`;

export default DialogStyled;
